export const getOrderArrayByNumber = (items: [], key: string) => {
  return items.sort((a, b) => {
    const aOrder = a[key] ? a[key] : 0
    const bOrder = b[key] ? b[key] : 0
    return aOrder - bOrder
  })
}

export function getOrderObjectArrayByNumber<T extends Record<string, any>>(items: T[], key: keyof T): T[] {
  return items.sort((a, b) => {
    const aOrder = a[key] ? a[key] : 0
    const bOrder = b[key] ? b[key] : 0
    return aOrder - bOrder
  })
}
